import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useFormControl } from "@mui/material/FormControl";
import { useTranslation } from "react-i18next";

// Qidiruvli select (davlat, dori shakli va boshqa {id, name} ro'yxatlar uchun).
// Formalar qiymatni document.getElementById(id).value orqali o'qiydi —
// shuning uchun tanlangan qiymat shu id dagi yashirin input'da saqlanadi.
export default function SearchSelect({ id, options: items, defaultValue, allowEmpty = false, disabled, placeholder }) {
  const { t } = useTranslation();
  const formControl = useFormControl();
  const isDisabled = disabled ?? formControl?.disabled ?? false;

  // NativeSelect kabi: bo'sh qiymatga ruxsat bo'lmasa, birinchi davlat tanlanadi
  const initial = () => {
    // eski kodda `${undefined}` kabi qiymatlar ham keladi
    if (defaultValue !== undefined && defaultValue !== null && !["", "undefined", "null"].includes(String(defaultValue)))
      return Number(defaultValue);
    return allowEmpty ? undefined : items?.[0]?.id;
  };
  const [value, setValue] = useState(initial);

  // ma'lumot keyin yuklansa yoki "avvalgi kiritilganlardan" tanlansa yangilansin
  useEffect(() => {
    setValue(initial());
  }, [defaultValue, items?.length]);

  return (
    <>
      <Select
        className="country-select"
        popupClassName="country-select__popup"
        showSearch
        allowClear={allowEmpty}
        disabled={isDisabled}
        value={value}
        onChange={(v) => setValue(v)}
        placeholder={placeholder || t("ln_select_search")}
        optionFilterProp="label"
        filterOption={(input, option) =>
          String(option?.label ?? "").toLowerCase().includes(input.trim().toLowerCase())
        }
        notFoundContent={t("No data")}
        options={(items || []).map((c) => ({ value: c.id, label: c.name }))}
        style={{ width: "100%" }}
      />
      <input type="hidden" id={id} value={value ?? ""} readOnly />
    </>
  );
}
